import styled from 'styled-components';

export const GraphicCardGeneral = styled.div`
  background: var(--primary);
  padding: 20px 30px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  div {
    h2 {
      text-align: left;
      font-size: 3.2rem;
      text-transform: uppercase;
      font-family: 'GothamBold';
      color: #434343;
    }
    h1 {
      text-align: left;
      font-size: 1.6rem;
      line-height: 1;
      color: #434343;
      text-transform: uppercase;
      font-family: 'GothamBold';
      padding: 10px 0;
    }
    p {
      color: #434343;
    }
  }
`;
